// Generated by CoffeeScript 1.11.1
var FormControl, FormControlFeedback, FormControlStatic, MaskedFormControl, MaskedInputField, React, bsClass, classNames, contextTypes, defaultProps, elementType, getClassSet, propTypes, ref,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FormControl = require('react-bootstrap').FormControl;

MaskedInputField = require('react-maskedinput');

ref = require('react-bootstrap/lib/utils/bootstrapUtils'), bsClass = ref.bsClass, getClassSet = ref.getClassSet;

FormControlFeedback = require('react-bootstrap/lib/FormControlFeedback');

FormControlStatic = require('react-bootstrap/lib/FormControlStatic');

React = require('react');

elementType = require('react-prop-types/lib/elementType');

classNames = require('classnames');

propTypes = {
  componentClass: elementType,
  type: React.PropTypes.string,
  id: React.PropTypes.string
};

defaultProps = {
  componentClass: 'input'
};

contextTypes = {
  $bs_formGroup: React.PropTypes.object
};

MaskedFormControl = (function(superClass) {
  extend(MaskedFormControl, superClass);

  function MaskedFormControl() {
    return MaskedFormControl.__super__.constructor.apply(this, arguments);
  }

  MaskedFormControl.prototype.render = function() {
    var className, classes, controlId, formGroup, id, k, props, ref1, ref2, type, v;
    formGroup = this.context.$bs_formGroup;
    controlId = formGroup && formGroup.controlId;
    ref1 = this.props, type = ref1.type, id = ref1.id, className = ref1.className;
    id || (id = controlId);
    props = {};
    ref2 = this.props;
    for (k in ref2) {
      v = ref2[k];
      if (k !== 'componentClass' && k !== 'type' && k !== 'id' && k !== 'className' && k !== 'bsClass') {
        props[k] = v;
      }
    }
    if (type !== 'file') {
      classes = getClassSet(this.props);
    }
    return React.createElement(MaskedInputField, Object.assign({}, props, {
      "type": type,
      "id": id,
      "className": classNames(className, classes)
    }));
  };

  return MaskedFormControl;

})(FormControl);

MaskedFormControl.propTypes = propTypes;

MaskedFormControl.defaultProps = defaultProps;

MaskedFormControl.contextTypes = contextTypes;

MaskedFormControl.Feedback = FormControlFeedback;

MaskedFormControl.Static = FormControlStatic;

module.exports = bsClass('form-control', MaskedFormControl);
